import * as React from "react";
import {
  Box, Grid, Paper, TextField, InputAdornment, Chip,
  Stack, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Typography
} from "@mui/material";
import {
  WarehouseOutlined,
  LocationOnOutlined,
} from "@mui/icons-material";

import AppTheme from "../../../shared-theme/AppTheme";
import ProductCard from "./ventas/productcard";
import InvoicePanel from "./ventas/invoicepanel";
import AppShellCobros from "./components/appshellcobros"; // <- importa el nuevo componente

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../../dashboard/theme/customizations";
import VentasScreen from "./ventas";
import PagosPrestamoScreen from "./pagos_prestamo";
import PagoInicialScreen from "./pago_inicial";
import AbrirTurnoDialog from "./gestion_turnos/abrirturnodialog";
import CerrarTurnoDialog from "./gestion_turnos/cerrarturnodialog";
import CargosScreen from "./cargos";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

const MOCK_PRODUCTS = [
  { id: "p1", name: "juwuw", price: 120, stock: 5, kind: "product", favorite: true },
  { id: "p2", name: "kdkd", price: 5, stock: 5, kind: "product" },
  { id: "s1", name: "Cambio de aceite", price: 850, stock: null, kind: "service" },
];

const DEFAULT_CLIENT = { id: "walkin", name: "Consumidor final" };

function NewClientDialog({ open, onClose, onCreate }) {
  const [name, setName] = React.useState("");
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Nuevo cliente</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="Nombre del cliente" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={() => { onCreate({ id: crypto.randomUUID(), name: name.trim() || "Cliente" }); onClose(); }}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function BillingScreen(props) {
  const [search, setSearch] = React.useState("");
  const [catalog, setCatalog] = React.useState(MOCK_PRODUCTS);
  const [cart, setCart] = React.useState([]);
  const [priceList, setPriceList] = React.useState("general");
  const [invoiceType, setInvoiceType] = React.useState("cf01");
  const [client, setClient] = React.useState(DEFAULT_CLIENT);
  const [showClientDialog, setShowClientDialog] = React.useState(false);
  const [showShiftDialog, setShowShiftDialog] = React.useState(false);
  const [shiftOpen, setShiftOpen] = React.useState(false);
  const [currentShift, setCurrentShift] = React.useState(null);
  const [showCloseShiftDialog, setShowCloseShiftDialog] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(localStorage.getItem('modulos').includes("productos_catalogo") ? 0 : localStorage.getItem('modulos').includes("prestamos") ? 1 : localStorage.getItem('modulos').includes("iniciales") ? 2 : 3);
  const [cargosProductos, setCargosProductos] = React.useState([]);
  const [selectedCargo, setSelectedCargo] = React.useState(null);

  const fetchCargosProductos = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/company/${localStorage.getItem('idcompany')}?aplicaA=producto`,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      }
    );
    const data = await response.json();
    setCargosProductos(data);
  };

  React.useEffect(() => {
    checkCurrentShift();
  }, []);

  React.useEffect(() => {
    fetchCargosProductos();
  }, []);


  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return catalog;
    return catalog.filter((p) => p.name.toLowerCase().includes(q));
  }, [search, catalog]);

  const addToCart = (item) => {
    setCart((prev) => {
      const found = prev.find((r) => r.id === item.id);
      if (found) return prev.map((r) => (r.id === item.id ? { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price } : r));
      return [...prev, { id: item.id, name: item.name, price: item.price, qty: 1, total: item.price }];
    });
  };
  const increase = (id) => setCart((p) => p.map((r) => (r.id === id ? { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price } : r)));
  const decrease = (id) => setCart((p) => p.map((r) => (r.id === id && r.qty > 1 ? { ...r, qty: r.qty - 1, total: (r.qty - 1) * r.price } : r)));
  const removeItem = (id) => setCart((p) => p.filter((r) => r.id !== id));

  const totals = React.useMemo(() => {
    const subtotal = cart.reduce((s, r) => s + r.total, 0);
    const taxes = 0;
    return { subtotal, taxes, total: subtotal + taxes };
  }, [cart]);

  React.useEffect(() => {
    setCart((prev) =>
      prev.map((r) => {
        const base = MOCK_PRODUCTS.find((p) => p.id === r.id)?.price ?? r.price;
        const price = priceList === "mayor" ? base * 0.95 : base;
        return { ...r, price, total: price * r.qty };
      })
    );
  }, [priceList]);


  const handleShiftOpened = (shiftId, initialCash) => {
    setShiftOpen(true);
    setCurrentShift({
      id: shiftId,
      monto_inicial: initialCash
    });
  };

  const handleShiftClosed = (shiftSummary) => {
    setShiftOpen(false);
    setCurrentShift(null);
    // You could show a summary dialog or notification here
    console.log('Shift closed with summary:', shiftSummary);
  };

  const checkCurrentShift = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pos/shifts/current?id_usuario=${localStorage.getItem('id')}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        if (result.has_open_shift) {
          setShiftOpen(true);
          setCurrentShift(result.shift);
        } else {
          setShiftOpen(false);
          setCurrentShift(null);
        }
      }
    } catch (error) {
      console.error('Error checking shift:', error);
      setShiftOpen(false);
    }
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <AppShellCobros
        title=" Bankivo · Centro de Cobros"
        rightContent={
          shiftOpen ? (
            <>
            <Stack direction="row" alignItems="center" spacing={5} mx={2} my={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                  <WarehouseOutlined color="primary"/>
                  <Typography >Almacen • {localStorage.getItem('nombre_almacen')}</Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                  <LocationOnOutlined sx={{marginLeft:10}} color="primary"/>
                  <Typography >Sucursal • {localStorage.getItem('nombre_sucursal')}</Typography>
              </Stack>
            </Stack>

            <Button
            variant="outlined"
            color="error"
            onClick={() => setShowCloseShiftDialog(true)}
            sx={{ ml: 'auto', fontWeight: "bold", borderColor: "error.main", color: "error.main" }}>
            Cerrar Turno
        </Button>
        </>
  
          ) : (
            <>
            <Stack direction="row" alignItems="center" spacing={5} mx={2} my={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                  <WarehouseOutlined />
                  <Typography >Almacen • {localStorage.getItem('nombre_almacen')}</Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                  <LocationOnOutlined sx={{marginLeft:10}} />
                  <Typography >Sucursal • {localStorage.getItem('nombre_sucursal')}</Typography>
              </Stack>
            </Stack>

            <Button
            variant="outlined"
            color="success"
            onClick={() => setShowShiftDialog(true)}
            sx={{ ml: 'auto', fontWeight: "bold", borderColor: "success.main", color: "success.main" }}>
              Abrir Turno
            </Button>
            </>
  
          )
        }
      >
        <Box sx={{ p: 2, mr: 5 }}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={8}>
              <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
                {localStorage.getItem('modulos').includes("productos_catalogo") && <Tab value={0} label="Producto/Servicio" sx={{ fontWeight: "bold", fontSize: 17, ml: 2 }} />}
                {localStorage.getItem('modulos').includes("prestamos") && <Tab value={1} label="Pago Prestamo" sx={{ fontWeight: "bold", fontSize: 17, ml: 2 }} />}
                {localStorage.getItem('modulos').includes("iniciales") && <Tab value={2} label="Inicial" sx={{ fontWeight: "bold", fontSize: 17, ml: 2 }} />}
                {cargosProductos.map(c => (
                  <Tab value={3} label={c.nombre} sx={{ fontWeight: "bold", fontSize: 17, ml: 2 }} onClick={() => setSelectedCargo(c)}/>
                ))}
               
              </Tabs>
            </Grid>
       
       
            {tabValue === 0 && (
              <Grid size={12}>
                <VentasScreen shiftOpen={shiftOpen}/>
              </Grid>
            )}
            {tabValue === 1 && (
              <Grid size={12}>
                <PagosPrestamoScreen shiftOpen={shiftOpen}/>
              </Grid>
            )}
            {tabValue === 2 && (
              <Grid size={12}>
                <PagoInicialScreen shiftOpen={shiftOpen}/>
              </Grid>
            )}
            {tabValue === 3 && (
              <Grid size={12}>
                <CargosScreen shiftOpen={shiftOpen} selectedCargo={selectedCargo} />
              </Grid>
            )}
          </Grid>
        </Box>


        <NewClientDialog
          open={showClientDialog}
          onClose={() => setShowClientDialog(false)}
          onCreate={(c) => setClient(c)}
        />
        <AbrirTurnoDialog
          open={showShiftDialog}
          onClose={() => setShowShiftDialog(false)}
          onShiftOpened={handleShiftOpened}
        />
        <CerrarTurnoDialog
          selectedCargo={selectedCargo}
          open={showCloseShiftDialog}
          onClose={() => setShowCloseShiftDialog(false)}
          onShiftClosed={handleShiftClosed}
          currentShift={currentShift}
        />
      </AppShellCobros>
    </AppTheme>
  );
}
